
<template>
  <div class="">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="!show_banner"
      :navbar_cols="attrs.navbar_cols ? attrs.navbar_cols : 4"
    ></CenterNavbar>
    <div class="inner-page-container">
      <div
        v-if="show_banner"
        class="text-center white d-flex flex-column justify-space-between align-center"
      >
        <div class="pt-10">
          <v-img
            width="450"
            height="400"
            max-height="400"
            contain
            src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605688003/botswana%20services/website%20assets/botswana-political-map_ywzvrz.jpg"
          >
          </v-img>
        </div>
        <p class="pa-10 text-h5 pb-0 pt-2 mb-15">
          Manage Country wide business locations, <br />
          including districts, cities, wards and streets
          <br />
          <br />
          <v-btn
            class="ma-1 mb-4 mr-10"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_add_new_district"
          >
            <v-icon left class="mobile-display-none">mdi-plus</v-icon>
            Add A New District
          </v-btn>
          <v-btn
            class="ma-1 mb-4"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_view_list_districts"
          >
            <v-icon left class="mobile-display-none">mdi-eye</v-icon>
            View Districts
          </v-btn>
          <br /><br />
        </p>
      </div>
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
        @set-page-attributes="on_set_page_attributes"
      ></router-view>
    </div>
  </div>
</template>

<script>
import SidePageColumn from "./../../../components/SidePageColumn";
import Utils from "./../../../lib/Utils";
import NavbarMenuItem from "./../../../components/NavbarMenuItem";
import CenterNavbar from "./../../../components/CenterNavbar";
import page_info from "./../../../lib/page_info";
export default {
  name: "AdminLocations",
  components: {
    SidePageColumn,
    NavbarMenuItem,
    CenterNavbar,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      sub_menu_items: [
        {
          label: "List Of Districts",
          icon: "mdi-view-list",
          to: "/admin/locations/districts/list",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Add a District",
          icon: "mdi-plus-box",
          to: "/admin/locations/districts/add",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "List Of Cities",
          icon: "mdi-view-list",
          to: "/admin/locations/cities/list",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Add a City",
          icon: "mdi-plus-box",
          to: "/admin/locations/cities/add",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "List Of Wards",
          icon: "mdi-view-list",
          to: "/admin/locations/wards/list",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Add A Ward",
          icon: "mdi-plus-box",
          to: "/admin/locations/wards/add",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "List Of Streets",
          icon: "mdi-view-list",
          to: "/admin/locations/streets/list",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Add A Street",
          icon: "mdi-plus-box",
          to: "/admin/locations/streets/add",
          roles: ["super role", "backofficcee"],
        },
      ],
      attrs: Utils.get_default_page_attr(),
      page_info: page_info,
      attrs: Utils.get_default_page_attr(),
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    go_to_add_new_district() {
      this.$router.push("/admin/locations/districts/add");
    },
    go_to_view_list_districts() {
      this.$router.push("/admin/locations/districts/view");
    },
    on_set_page_attributes(attrs) {
      this.attrs = attrs;
    },
  },
  computed: {
    show_banner() {
      if (this.$route.path == "/admin/locations") {
        return true;
      }
      return false;
    },
  },
};
</script>